import {
  TextInput,
  Text,
  Grid,
  Button,
  Tabs,
  Group,
  ActionIcon,
  ScrollArea,
  SimpleGrid,
  LoadingOverlay,
  Select,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { Trash } from "tabler-icons-react";
import { useMutation, useQuery } from "@apollo/client";
import React, { useState, useRef } from "react";
import { useViewportSize } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
import { customLoader } from "components/utilities/loader";
import { GET_Attributes, NON_PAGINATED_CATEGORIES } from "apollo/queries";
import { CREATE_Attribute, UPDATE_Attribute } from "apollo/mutuations";
import { useEffect } from "react";

export default function AttributeEditModal({
  setOpenedEdit,
  total,
  setTotal,
  activePage,
  setActivePage,
  attribute,
}) {
  const form = useForm({
    initialValues: {
      name: "",
      category_id: 1,
    },
  });
  const [dropDownData, setDropDownData] = useState([]);

  const { loading: categoryLoading, refetch } = useQuery(
    NON_PAGINATED_CATEGORIES,
    {
      onCompleted(data) {
        const enArr = data.categoryNonPaginated.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        setDropDownData(enArr);
      },
    }
  );
  useEffect(() => {
    refetch();
  }, []);
  useEffect(() => {
    if (attribute) {
      form.setValues({
        name: attribute?.name,
        category_id: attribute?.category.id,
      });
    }
  }, [attribute]);
  const [updateAttribute, { loading }] = useMutation(UPDATE_Attribute);

  const submit = () => {
    let variables = {
      id: attribute.id,
      name: form.getInputProps("name").value,
      category_id: form.getInputProps("category_id").value,
    };
    console.log(variables);
    updateAttribute({
      variables,
      onCompleted() {
        showNotification({
          color: "green",
          title: "Success",
          message: "Attribute Updated Successfully",
        });
        setOpenedEdit(false);
      },
      onError(error) {
        showNotification({
          color: "red",
          title: "Error",
          message: error?.graphQLErrors?.[0]?.message || "Failed to update attribute",
        });
      },
    });
  };

  const { height } = useViewportSize();
  const handleCategoryChange = (val) => {
    form.setFieldValue("category_id", val);
  };
  return (
    <>
      <LoadingOverlay
        visible={loading}
        color="blue"
        overlayBlur={2}
        loader={customLoader}
      />

      <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
        <form onSubmit={form.onSubmit(() => submit())} noValidate>
          <Grid>
            <Grid.Col span={6}>
              <TextInput
                required
                label="Name"
                placeholder="Enter Attribute name"
                {...form.getInputProps("name")}
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <Select
                searchable
                data={dropDownData}
                value={form.getInputProps("category_id").value.toString()}
                onChange={handleCategoryChange}
                label="Category"
                placeholder="Pick a category"
              />{" "}
            </Grid.Col>
            <Grid.Col span={12}>
              <Button
                style={{
                  width: "25%",
                  marginTop: "15px",
                  backgroundColor: "#FF6A00",
                  color: "#FFFFFF",
                }}
                type="submit"
                color="blue"
                fullWidth
              >
                Submit
              </Button>
            </Grid.Col>
          </Grid>
        </form>
      </ScrollArea>
    </>
  );
}
